import { RefObject, useEffect, useRef, useState } from 'react';

export const useNearViewport = <T extends Element>(rootMargin = '300px'): [RefObject<T>, boolean] => {
  const ref = useRef<T>(null);
  const [near, setNear] = useState<boolean>(() => typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    if (near) return undefined;

    const el = ref.current;

    if (!el || typeof IntersectionObserver === 'undefined') {
      setNear(true);

      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setNear(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, [near, rootMargin]);

  return [ref, near];
};
